// api.js
import axios from 'axios';
import { API_URL } from '../utils/ApiUrl';

const api = axios.create({
  baseURL: API_URL,
}); 

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn('Unauthorized access - maybe redirect to login');
    }
    return Promise.reject(error);
  }
);

// Generic request function
// Generic request function
export const makeRequest = async (url, method = 'GET', data = null, customBaseURL = null) => {
  try {
    const response = await api.request({
      url,
      method,
      data,
      baseURL: customBaseURL || api.defaults.baseURL,
    });
    return response.data;
  } catch (error) {
    console.error('API Request Error:', error);

    // 🔥 This will pass the actual backend error body to your caller
    throw error.response?.data || error;
  }
};



export default api;
